class tv2zAnalytics {
  isInited = false;

  setUser(userId = 'Unknown Hamster') {
    if (window._paq) {
      window._paq.push(['setUserId', userId.toString()]);
      window._paq.push(['setCustomDimension', 1, userId]);

      if (!this.isInited) {
        window._paq.push(['trackPageView']);
        window._paq.push(['enableLinkTracking']);
        this.isInited = true;
      }
    }
  }

  setContentInfo(assetId = null, type = 'UNKNOWN', programId, duration) {
    if (window._paq) {
      window._paq.push(['setCustomDimension', 2, assetId]);

      if (['movie', 'episode', 'series'].indexOf(type) !== -1) {
        window._paq.push(['setCustomDimension', 3, 'VOD']);
      }

      if (type === 'channel') {
        window._paq.push(['setCustomDimension', 3, 'LIVE']);
        window._paq.push(['setCustomDimension', 5, duration || 'null']);
      }

      if (['catchup', 'npvr'].indexOf(type) !== -1) {
        window._paq.push(['setCustomDimension', 3, 'RECORD']);
        window._paq.push(['setCustomDimension', 5, duration || 'null']);
      }

      window._paq.push(['setCustomDimension', 4, programId || assetId]);
    }
  }

  initScan() {
    if (window._paq) {
      window._paq.push(['MediaAnalytics::scanForMedia']);
    }
  }
}

export default new tv2zAnalytics();



// WEBPACK FOOTER //
// ./src/services/tv2z.js